import { API_BASE } from './api-config';
import { useAuthStore } from '../stores/authStore';

function authHeaders(): Record<string, string> {
  const token = useAuthStore.getState().token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...options.headers,
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const message = (body as { message?: string }).message ?? `HTTP ${res.status}`;
    throw new Error(message);
  }

  return res.json() as Promise<T>;
}

export interface Finding {
  id: string;
  type: 'email' | 'todo' | 'note' | 'reminder' | 'insight';
  priority: 1 | 2 | 3;
  title: string;
  description: string;
  sourceEntity: string;
  sourceType: 'email' | 'todo' | 'note';
  actionLabel: string;
  actionUrl: string;
  createdAt: string;
  dismissed: boolean;
}

interface FindingsResponse {
  findings: Finding[];
}

interface DismissResponse {
  success: boolean;
}

export const findingsApi = {
  load(): Promise<FindingsResponse> {
    return apiFetch<FindingsResponse>('/findings/');
  },

  refresh(): Promise<FindingsResponse> {
    return apiFetch<FindingsResponse>('/findings/refresh', { method: 'POST' });
  },

  dismiss(findingId: string): Promise<DismissResponse> {
    return apiFetch<DismissResponse>(`/findings/${findingId}/dismiss`, { method: 'POST' });
  },
};
